module.exports = __webpack_public_path__ + "img/上海振华LOGO.10e8afb3.png";